<template>
<div class="bytee-quiz">
  <p>
    Welcome to ScrumQuiz.org - your free Scrum practice! <br>
    <b>All the questions based on the Scrum Guide v2020.</b> <br>
  </p>
  <p>
    To help you get there, ScrumQuiz.org offers free practice tests
    with realistic exam questions. Enjoy!
  </p>
  <br>
  <div class="docs-demo columns">
    <div class="column col-6 col-xs-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title h5">Scrum Master Practice Test</div>
          <div class="card-subtitle text-gray">Exam simulation</div>
        </div>
        <div class="card-body">
          This quiz contains 40 questions focused on the Scrum Master exam topics, which you have
          to answer in 30 minutes. All the questions based on the Scrum Guide v2020.
        </div>
        <div class="card-footer">
          <router-link
            to="/scrum-master-practice-test"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
          >
            <a class="btn btn-primary" :href="href" @click="navigate">Start test</a>
          </router-link>
        </div>
      </div>
    </div>
    <div class="column col-6 col-xs-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title h5">Product Owner Practice Test</div>
          <div class="card-subtitle text-gray">Exam simulation</div>
        </div>
        <div class="card-body">
          This quiz contains 40 questions focused on the Product Owner exam topics, which you have
          to answer in 30 minutes. All the questions based on the Scrum Guide v2020.
        </div>
        <div class="card-footer">
          <router-link
            to="/product-owner-practice-test"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
          >
            <a class="btn btn-primary" :href="href" @click="navigate">Start test</a>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'home',
  components: {},
};
</script>

<style>
  .quiz-info {
    margin-bottom: 10px;
  }
</style>
